import { useState } from "react";
import PropTypes from "prop-types";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbarCustom from "examples/Navbars/DashboardNavbarCustom";
import Register2FAIntroduce from "./Register2FAIntroduce";
import Register2FARetypePassWord from "./Register2FARetypePassWord";
import Register2FAChooseType from "./Register2FAChooseType";
import Register2FACheckOTPFirst from "./Register2FACheckOTPFirst";
import Register2FAPatternLock from "./Register2FAPatternLock";

function TwoFA({ workingPage, childPage }) {
  const [openIntroduce, setOpenIntroduce] = useState(true);
  const [openReEnterPassword, setOpenReEnterPassword] = useState(false);
  const [open2FAChooseType, setOpen2FAChooseType] = useState(false);
  const [openCheckOTPFirst, setOpenCheckOTPFirst] = useState(false);
  const [openPatternLock, setOpenPatternLock] = useState(false);
  const [type, setType] = useState("");
  const backButton = () => {
    if (openReEnterPassword) {
      setOpenIntroduce((prev) => !prev);
      setOpenReEnterPassword((prev) => !prev);
    } else if (open2FAChooseType) {
      setOpenReEnterPassword((prev) => !prev);
      setOpen2FAChooseType((prev) => !prev);
    } else if (openCheckOTPFirst) {
      setOpen2FAChooseType((prev) => !prev);
      setOpenCheckOTPFirst((prev) => !prev);
    } else if (openPatternLock) {
      setOpenCheckOTPFirst((prev) => !prev);
      setOpenPatternLock((prev) => !prev);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbarCustom page={workingPage} childPage={childPage} backButton={backButton} />
      {openIntroduce ? (
        <Register2FAIntroduce
          setOpenIntroduce={setOpenIntroduce}
          setOpenReEnterPassword={setOpenReEnterPassword}
        />
      ) : null}
      {openReEnterPassword ? (
        <Register2FARetypePassWord
          setOpenIntroduce={setOpenIntroduce}
          setOpenReEnterPassword={setOpenReEnterPassword}
          setOpen2FAChooseType={setOpen2FAChooseType}
        />
      ) : null}
      {open2FAChooseType ? (
        <Register2FAChooseType
          setOpenReEnterPassword={setOpenReEnterPassword}
          setOpen2FAChooseType={setOpen2FAChooseType}
          setOpenCheckOTPFirst={setOpenCheckOTPFirst}
          setType={setType}
        />
      ) : null}
      {openCheckOTPFirst ? <Register2FACheckOTPFirst type={type} /> : null}
      {openPatternLock ? <Register2FAPatternLock type={type} /> : null}
    </DashboardLayout>
  );
}

TwoFA.defaultProps = {
  workingPage: "",
  childPage: [],
};

TwoFA.propTypes = {
  workingPage: PropTypes.string,
  childPage: PropTypes.arrayOf(PropTypes.string),
};

export default TwoFA;
